export enum COMPONENTLIST {
  SELECT = "select",
  TEXTAREA = "textarea",
  RADIO = "radio",
  DATE = "date",
  FILE = "file",
  DISTANCEINPUT = "distanceInput",
  TOGGLE = "toggle",
}

export const LAYOUT_OPTIONS = {
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical",
} as const;

export type LayoutOptions =
  (typeof LAYOUT_OPTIONS)[keyof typeof LAYOUT_OPTIONS];
